export function hideProp(obj, key, value) {
  Object.defineProperty(obj, key, {
    enumerable: false,
    ...value
  });
}
//# sourceMappingURL=hideProp.js.map
